import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {USER_PRIVILEGES} from '../../../../constants/privileges';
import {PAGE_SIZE_DEFAULT, PAGE_SIZE_OPTIONS} from '../../../../constants/paginator';
import {UsersTableComponent} from '../../../components/tables/users-table/users-table.component';
import {UserFilters} from '../../../data/models/filters/user-filters';
import {UsersDataSource} from '../../../data/source/UsersDataSource';
import {ActivatedRoute, Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {MeService} from '../../../services/api/me.service';
import {UserService} from '../../../services/api/user.service';
import {UserCreateDialogComponent} from '../../../components/dialogs/user-create-dialog/user-create-dialog.component';

@Component({
  selector: 'app-users-page',
  templateUrl: './users-page.component.html',
  styleUrls: ['./users-page.component.css']
})
export class UsersPageComponent implements OnInit, AfterViewInit {

  readonly PRIVILEGES = USER_PRIVILEGES;
  readonly pageSizeOptions = PAGE_SIZE_OPTIONS;
  readonly displayedColumns = [
    'id', 'surname', 'name', 'patronymic', 'mail',
    'registerDate', 'blockDate', 'roles'];

  @ViewChild(UsersTableComponent) usersTable!: UsersTableComponent;

  filters: UserFilters = {};
  dataSource: UsersDataSource;
  sort: string[] = ['surname', 'asc'];
  pageSize = PAGE_SIZE_DEFAULT;
  pageNumber = 0;

  get queryParams(): object {
    return {
      ...this.filters,
      sort: this.sort,
      size: this.pageSize,
      number: this.pageNumber,
    };
  }

  canAdd = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private meService: MeService,
    private userService: UserService,
  ) {
    this.dataSource = new UsersDataSource(this.userService);
    this.canAdd = this.meService.hasPrivilege(this.PRIVILEGES.CREATE);
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (Object.keys(params).length === 0) {
        this.router.navigate([], {
          replaceUrl: true,
          queryParams: this.queryParams,
        });
      } else {
        this.setFilters({
          search: params.search,
        });
        this.setSort(params.sort);
        this.setPage(params.size, params.number);
        this.loadData();
      }
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.usersTable.sort$.subscribe(sort => {
        this.setSort([sort.active, sort.direction]);
        this.navigate();
      });
      this.usersTable.page$.subscribe(event => {
        this.setPage(event.pageSize, event.pageIndex);
        this.navigate();
      });
    }, 0);
  }

  loadData(): void {
    this.dataSource.loadUsers({
        ...this.filters,
        isDeleted: false,
      },
      this.sort, this.pageSize, this.pageNumber);
  }

  setFilters(filters: UserFilters): void {
    this.filters = filters;
  }

  setSort(sort: string[]): void {
    if (Array.isArray(sort) && sort.length === 2) {
      this.sort = sort;
    }
  }

  setPage(pageSize: number, pageNumber: number): void {
    pageSize = +pageSize;
    pageNumber = +pageNumber;
    if (Number.isInteger(pageSize) && pageSize > 0) {
      this.pageSize = pageSize;
    }
    if (Number.isInteger(pageNumber) && pageNumber >= 0) {
      this.pageNumber = pageNumber;
    }
  }

  onFiltersChange(filters: UserFilters): void {
    if (filters.search === this.filters.search) {
      this.loadData();
    } else {
      this.setFilters(filters);
      this.setPage(this.pageSize, 0);
      this.navigate();
    }
  }

  navigate(): void {
    this.router.navigate([], {
      queryParams: this.queryParams,
    });
  }

  openUserCreateDialog(): void {
    const dialogRef = this.dialog.open(UserCreateDialogComponent, {
      maxWidth: '400px',
      data: {}
    });

    dialogRef.afterClosed().subscribe(user => {
      if (user) {
        this.dataSource.insertUser(user);
      }
    });
  }

}
